'use client';

import { useState, type FunctionComponent } from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames/bind';
import { Text } from '@fff-web/ui-components';
import { cLog } from '../../../_utils/logging/client';
import styles from './DraftModeBanner.module.scss';

const cx = classNames.bind(styles);

const SANITY_DRAFT_QUERY_PARAM = 'sanity-preview-perspective';

export const DraftModeBanner: FunctionComponent = () => {
  const [isLoading, setIsLoading] = useState(false);

  const onDisableDraftMode = async () => {
    try {
      setIsLoading(true);

      // Get current URL without draft query params
      const url = new URL(window.location.href);
      url.searchParams.delete(SANITY_DRAFT_QUERY_PARAM);

      // Navigate to disable endpoint, which will clear cookie and redirect
      window.location.href = `/api/draft/disable?redirect=${encodeURIComponent(url.pathname + url.search)}`;
    } catch (error) {
      setIsLoading(false);
      cLog?.error(
        {
          context: 'DraftModeBanner',
          type: 'client',
          message: 'Draft mode could not be disabled. Please verify the error.',
        },
        { error },
      );
    }
  };

  return (
    <div className={cx('DraftModeBanner')} role="alert">
      {isLoading ? (
        <FontAwesomeIcon icon={faSpinner} className={cx('DraftModeBanner__spinner')} />
      ) : (
        <Text>
          You are in{' '}
          <Text weight="extra-bold" as="b">
            Draft Mode
          </Text>
          , all draft content is visible. To disable it click{' '}
          <button onClick={onDisableDraftMode}>
            {' '}
            <Text weight="extra-bold" as="b">
              here
            </Text>
          </button>
          .
        </Text>
      )}
    </div>
  );
};
